import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// THE SOCIAL LAYER — self-identifying, follows the player across every screen.
// Mark is PASSED IN rather than imported by IEFriends, so titles without the
// achievement stack can still carry the friends list. See IEFriends.js.
import IESocialDock from './IEFriends';
import Mark from './Mark';
import { SD } from './theme';
// AEMILIA — the Empire's guide. Same layer, same behaviour in every title;
// the Pier only says where its chrome is (button/perches) and, from
// UnstablePierre.js, what it can open. Master: gamemaster/engine/AemiliaGuide.js
import AemiliaGuide from './AemiliaGuide';
// THE MENU BACKDROP — the Empire's one menu (Aemilia's house). Same layer, same
// behaviour in every title; the Pier hands it rows from UnstablePierre.js.
// Master: gamemaster/engine/MenuBackdrop.js (+ ieBackdrop.js, its store).
import MenuBackdrop from './MenuBackdrop';

const root = ReactDOM.createRoot(document.getElementById('root'));

// ⚑ THE DEV PREVIEWS — `?preview=pier` and `?preview=minerium` mount a 3D
// renderer with real data and no login, so a change can be walked and
// screenshotted. See PierPreview.jsx / MineriumPreview.jsx.
// ⚠ THE NODE_ENV TEST IS ON THE SAME EXPRESSION AS THE import() CALLS, on
// purpose. Webpack only drops a dynamic import when the branch holding it
// is a constant at that site; tested through a variable, the chunk would
// still be emitted into a production build (never loaded, but shipped).
const loadPreview = process.env.NODE_ENV === 'development'
  ? ({
      pier: () => import('./PierPreview'),
      minerium: () => import('./MineriumPreview'),
      hall: () => import('./HallPreview'),
    })[new URLSearchParams(window.location.search).get('preview')]
  : null;

if (loadPreview) {
  const Preview = React.lazy(loadPreview);
  root.render(
    <React.Suspense fallback={null}>
      <Preview />
    </React.Suspense>
  );
} else root.render(
  <React.StrictMode>
    <App />
    {/* ⚠ `#38bdf8` is MARK_ACCENTS.sky. The Pier is gold and violet, and
        this is the one social affordance that is on screen at ALL times —
        so the always-visible pill glowed cyan in a game with no cyan in
        its chrome. The Mark's own panel keeps its Bodoni-obsidian
        identity look, deliberately; only the pier-side accent moves. */}
    <IESocialDock game="pier" accent={SD.gold} MarkView={Mark} />
    {/* Her button sits bottom-left ABOVE the chat bubble (bottom 20, 44px) and
        the 3D camera bar; on touch the bar wraps to ~3 rows and the 3D interact
        pill floats at bottom 96, hence 140. She paints ABOVE all Pier chrome
        (the Pier's root is its own stacking context), so perches must clear it:
        minTop 190 = below the party roster (top 58, up to ~4 rows). A perch that
        can't fit (short landscape phone) is skipped; none left = she's the pill. */}
    <AemiliaGuide
      game="pier"
      button={{ left: 14, bottom: 76 }}
      buttonTouch={{ left: 14, bottom: 140 }}
      perches={[{ x: 5, y: 46 }, { x: 94, y: 44 }, { x: 6, y: 58 }]}
      minTop={190}
    />
    {/* THE BACKDROP BAND — Terror's band, shared: on a computer a painted strip
        down the right (☰ menu, world chat as the log, Friends, Party, Aemilia's
        nook); the 3D pier leaves room for it. On a phone: a ☰ MENU pill
        bottom-left (where the chat bubble and camera bar were; the D-pad is
        bottom-right) opening the same contents as a sheet. */}
    <MenuBackdrop
      title="W'ily's Pier"
      accent={SD.gold}
      pillTouch={{ left: 14, bottom: 20 }}
      storageKey="pier.band.v1"
      defaultPanel="log"
    />
  </React.StrictMode>
);
